<template>
    <div class="intro-page">
        <!-- PC 端布局 -->
        <div class="intro-pc" v-show="isPC">
            <div class="company-intro-container">
                <!-- 子公司简介列表 -->
                <div class="sub-company-list">
                    <!-- 湖北禹航物产有限责任公司 -->
                    <section class="intro-section sub-company">
                        <div class="section-title">
                            <h3>湖北禹航物产有限责任公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北禹航物产有限责任公司于2024年12月19日注册成立，是湖北水发集团的全资子公司，注册资本金20亿元，是集团水利供应链管理主体与重大项目物资保障压舱石，“保供稳链、降本增效”的关键专业力量。公司锚定“3+1+N”发展思路，紧扣水利工程全生命周期与涉水产业上下游延链补链强链，做强水利物资供应、做优水利产业布局、做精涉水快消品业务，打造水利物资工业互联网核心平台，培育N个细分特色板块。以数字化驱动供应链升级，争创“专精特新”企业，打造“水发优品”品牌，铸就全国知名智慧型水利供应链服务商，为集团重大工程筑牢供应链支撑。</p>
                        </div>
                    </section>

                    <!-- 湖北水发汉江控股有限公司 -->
                    <section class="intro-section sub-company">
                        <div class="section-title">
                            <h3>湖北水发汉江控股有限公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北水发汉江控股有限公司2025年4月在襄阳注册成立，注册资本2亿元，由集团全资子公司鄂北水资源开发有限责任公司100%控股。公司聚焦鄂北工程沿线（襄阳、随州和孝感等重点区域）的涉水业务，依托鄂北水资源配置工程优势，整合区域涉水资产，聚焦“城乡供排水一体化运营、高效节水与水资源循环利用”两大核心业务，实现区域涉水业务“投、建、管、运”一体化发展。业务范围涵盖水资源综合开发与保护、水利基础设施和污水处理等各类水利工程投建管运、涉水产业投资与咨询等。</p>
                        </div>
                    </section>

                    <!-- 湖北水利发展集团十堰投资开发有限公司 -->
                    <section class="intro-section sub-company">
                        <div class="section-title">
                            <h3>湖北水利发展集团十堰投资开发有限公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北水利发展集团十堰投资开发有限公司，是集团深耕鄂西北市场的核心战略支点，也是推动市县协同发展的主力平台。公司聚焦水利水务全产业链发展，重点布局优质水资源及具备稳定现金流的优质经营性资产，发展根基扎实、前景广阔。我们坚守国企使命，以守护水源生态、助力绿色发展为己任，构建起“三大主业、两大支撑、两条价值链” 的成熟业务体系，业务版图多元、发展空间充足。依托省属大型国企平台优势，公司拥有完善的发展通道、专业的培养体系，诚邀各界英才携手同行，共拓水利水务事业新未来。</p>
                        </div>
                    </section>

                    <!-- 湖北楚禹水务科技有限公司 -->
                    <section class="intro-section sub-company">
                        <div class="section-title">
                            <h3>湖北楚禹水务科技有限公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北楚禹水务科技有限公司成立于2005年，隶属湖北水利发展集团，深耕水利信息化二十余年，是国家高新技术企业、湖北省专精特新企业、武汉大学智慧水务研究转化基地，公司先后荣获全国工人先锋号、国家地理信息科技进步奖、长江科学技术奖等多项国家级、省部级荣誉。作为湖北水利发展集团数智化转型领航者与水利科技创新主平台，公司秉持“用科技重新定义水利”的使命，以“市场拓展、科技创新、资本赋能”为驱动力，着力布局智慧水利、智慧水务、智能装备、数智服务等业务，打造“硬件+软件+数据+服务”一体化解决方案，争当全国一流的水利科技解决方案提供商。</p>
                        </div>
                    </section>

                    <!-- 湖北瑞洪工程管理有限公司 -->
                    <section class="intro-section sub-company">
                        <div class="section-title">
                            <h3>湖北瑞洪工程管理有限公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北瑞洪工程管理有限公司隶属于湖北省属大型国有企业-湖北水利发展集团有限公司。公司拥有水利工程施工监理甲级、机电及金属结构设备制造监理乙级、水土保持工程施工监理乙级等5项专业资质，通过ISO三大管理体系认证，是湖北省监理行业标杆企业。公司主要从事水利工程、房屋建筑、市政公用工程等领域的监理、造价咨询、招标代理、工程检测及运营维护业务。累计承接项目700余项，承监项目2次获中国水利优质工程“大禹奖”、17次获湖北水利工程优质奖“江汉杯”，在业内享有盛誉。作为水利部AAA级信用企业，公司同时获评湖北省高新技术企业、“专精特新”中小企业等称号。</p>
                            <p>公司下设6个职能部门、4家分公司和1家子公司，始终坚持“独立、公开、科学、严谨”的监理原则，凝心聚力、实干笃行，全力打造全国一流的全过程咨询标杆企业。</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>

        <!-- 移动端布局 -->
        <div class="intro-mobile" v-show="!isPC">
            <div class="mobile-intro-container">
                <!-- 子公司简介列表 -->
                <div class="sub-company-mobile-list">
                    <!-- 湖北禹航物产有限责任公司 -->
                    <section class="intro-section mobile-section sub-company">
                        <div class="section-title">
                            <h3>湖北禹航物产有限责任公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北禹航物产有限责任公司于2024年12月19日注册成立，是湖北水发集团的全资子公司，注册资本金20亿元，是集团水利供应链管理主体与重大项目物资保障压舱石，“保供稳链、降本增效”的关键专业力量。公司锚定“3+1+N”发展思路，紧扣水利工程全生命周期与涉水产业上下游延链补链强链，做强水利物资供应、做优水利产业布局、做精涉水快消品业务，打造水利物资工业互联网核心平台，培育N个细分特色板块。以数字化驱动供应链升级，争创“专精特新”企业，打造“水发优品”品牌，铸就全国知名智慧型水利供应链服务商，为集团重大工程筑牢供应链支撑。</p>
                        </div>
                    </section>

                    <!-- 湖北水发汉江控股有限公司 -->
                    <section class="intro-section mobile-section sub-company">
                        <div class="section-title">
                            <h3>湖北水发汉江控股有限公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北水发汉江控股有限公司2025年4月在襄阳注册成立，注册资本2亿元，由集团全资子公司鄂北水资源开发有限责任公司100%控股。公司聚焦鄂北工程沿线（襄阳、随州和孝感等重点区域）的涉水业务，依托鄂北水资源配置工程优势，整合区域涉水资产，聚焦“城乡供排水一体化运营、高效节水与水资源循环利用”两大核心业务，实现区域涉水业务“投、建、管、运”一体化发展。业务范围涵盖水资源综合开发与保护、水利基础设施和污水处理等各类水利工程投建管运、涉水产业投资与咨询等。</p>
                        </div>
                    </section>

                    <!-- 湖北水利发展集团十堰投资开发有限公司 -->
                    <section class="intro-section mobile-section sub-company">
                        <div class="section-title">
                            <h3>湖北水利发展集团十堰投资开发有限公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北水利发展集团十堰投资开发有限公司，是集团深耕鄂西北市场的核心战略支点，也是推动市县协同发展的主力平台。公司聚焦水利水务全产业链发展，重点布局优质水资源及具备稳定现金流的优质经营性资产，发展根基扎实、前景广阔。我们坚守国企使命，以守护水源生态、助力绿色发展为己任，构建起“三大主业、两大支撑、两条价值链” 的成熟业务体系，业务版图多元、发展空间充足。依托省属大型国企平台优势，公司拥有完善的发展通道、专业的培养体系，诚邀各界英才携手同行，共拓水利水务事业新未来。</p>
                        </div>
                    </section>

                    <!-- 湖北楚禹水务科技有限公司 -->
                    <section class="intro-section mobile-section sub-company">
                        <div class="section-title">
                            <h3>湖北楚禹水务科技有限公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北楚禹水务科技有限公司成立于2005年，隶属湖北水利发展集团，深耕水利信息化二十余年，是国家高新技术企业、湖北省专精特新企业、武汉大学智慧水务研究转化基地，公司先后荣获全国工人先锋号、国家地理信息科技进步奖、长江科学技术奖等多项国家级、省部级荣誉。作为湖北水利发展集团数智化转型领航者与水利科技创新主平台，公司秉持“用科技重新定义水利”的使命，以“市场拓展、科技创新、资本赋能”为驱动力，着力布局智慧水利、智慧水务、智能装备、数智服务等业务，打造“硬件+软件+数据+服务”一体化解决方案，争当全国一流的水利科技解决方案提供商。</p>
                        </div>
                    </section>

                    <!-- 湖北瑞洪工程管理有限公司 -->
                    <section class="intro-section mobile-section sub-company">
                        <div class="section-title">
                            <h3>湖北瑞洪工程管理有限公司</h3>
                        </div>
                        <div class="section-content">
                            <p>湖北瑞洪工程管理有限公司隶属于湖北省属大型国有企业-湖北水利发展集团有限公司。公司拥有水利工程施工监理甲级、机电及金属结构设备制造监理乙级、水土保持工程施工监理乙级等5项专业资质，通过ISO三大管理体系认证，是湖北省监理行业标杆企业。公司主要从事水利工程、房屋建筑、市政公用工程等领域的监理、造价咨询、招标代理、工程检测及运营维护业务。累计承接项目700余项，承监项目2次获中国水利优质工程“大禹奖”、17次获湖北水利工程优质奖“江汉杯”，在业内享有盛誉。作为水利部AAA级信用企业，公司同时获评湖北省高新技术企业、“专精特新”中小企业等称号。</p>
                            <p>公司下设6个职能部门、4家分公司和1家子公司，始终坚持“独立、公开、科学、严谨”的监理原则，凝心聚力、实干笃行，全力打造全国一流的全过程咨询标杆企业。</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "TabIntro",
    data() {
        return {
            isPC: true
        };
    },
    mounted() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        onResize() {
            // 移动端阈值：992px
            this.isPC = window.innerWidth >= 992;
        }
    }
};
</script>
<style scoped lang="less">
.intro-page {
    width: 100%;
    padding: 20px 0;
    background-color: #f9f9f9;
}
// PC端样式
.intro-pc {
    .company-intro-container {
        width: 90%;
        max-width: 1200px;
        margin: 0 auto;
        background: #fff;
        padding: 30px 40px;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        .intro-section {
            margin-bottom: 40px;
            &:last-child {
                margin-bottom: 0;
            }
            .section-title {
                text-align: center;
                margin-bottom: 20px;
                position: relative;
                h2 {
                    font-size: 28px;
                    color: #006699;
                    margin: 0 0 8px;
                    position: relative;
                    &::after {
                        content: '';
                        display: block;
                        width: 70px;
                        height: 4px;
                        background: #0099cc;
                        margin: 10px auto 0;
                    }
                }
                h3 {
                    font-size: 22px;
                    color: #006699;
                    margin: 0 0 8px;
                    position: relative;
                    &::after {
                        content: '';
                        display: block;
                        width: 50px;
                        height: 3px;
                        background: #0099cc;
                        margin: 8px auto 0;
                    }
                }
                .en-title {
                    font-size: 14px;
                    color: #999;
                    text-transform: uppercase;
                }
            }
            .section-content {
                line-height: 1.8;
                font-size: 16px;
                color: #333;
                text-align: justify;
                p {
                    margin-bottom: 16px;
                    text-indent: 2em;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
        /* PC改为单列，每个子公司独立一排 */
        .sub-company-list {
            display: grid;
            grid-template-columns: 1fr;
            gap: 30px;
            .sub-company {
                margin-bottom: 0;
                padding: 20px;
                background: #f5f8fa;
                border-radius: 6px;
                .section-content {
                    font-size: 15px;
                }
            }
        }
    }
}
// 移动端样式
.intro-mobile {
    .mobile-intro-container {
        width: 95%;
        margin: 0 auto;
        background: #fff;
        padding: 20px 15px;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
        .mobile-section {
            margin-bottom: 30px;
            &:last-child {
                margin-bottom: 0;
            }
            .section-title {
                text-align: center;
                margin-bottom: 15px;
                h2 {
                    font-size: 22px;
                    color: #006699;
                    margin: 0 0 6px;
                    &::after {
                        content: '';
                        display: block;
                        width: 60px;
                        height: 3px;
                        background: #0099cc;
                        margin: 8px auto 0;
                    }
                }
                h3 {
                    font-size: 18px;
                    color: #006699;
                    margin: 0 0 6px;
                    &::after {
                        content: '';
                        display: block;
                        width: 40px;
                        height: 2px;
                        background: #0099cc;
                        margin: 6px auto 0;
                    }
                }
                .en-title {
                    font-size: 12px;
                    color: #999;
                }
            }
            .section-content {
                line-height: 1.7;
                font-size: 14px;
                color: #333;
                p {
                    margin-bottom: 12px;
                    text-indent: 2em;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            .sub-company {
                background: #f5f8fa;
                padding: 15px;
                border-radius: 4px;
            }
        }
    }
}
// 响应式显隐
@media screen and (max-width: 991px) {
    .intro-pc {
        display: none !important;
    }
}
@media screen and (min-width: 992px) {
    .intro-mobile {
        display: none !important;
    }
}
</style>